"use client";

import { useSyncExternalStore } from "react";
import {
  getCartLineCount,
  getCartSnapshot,
  getServerCartSnapshot,
  subscribeCart,
  type CartLine,
} from "@/lib/cart";

// CookieBanner.tsx와 같은 이유로 useSyncExternalStore를 쓴다: 서버/최초
// 하이드레이션은 항상 빈 장바구니 스냅샷을 쓰고, 마운트 직후 실제
// 로컬스토리지 값으로 react가 알아서 재렌더한다. useEffect+setState 패턴이
// 남기는 하이드레이션 불일치 없이, 다른 탭에서의 변경도 자동으로 반영된다.
export function useCartLines(): CartLine[] {
  return useSyncExternalStore(
    subscribeCart,
    getCartSnapshot,
    getServerCartSnapshot,
  );
}

export function useCartLineCount(): number {
  const lines = useCartLines();
  return getCartLineCount(lines);
}
